"use strict";

exports.__esModule = true;
exports.AlertsPerDeviceChart = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Core = require("../../../Core");
var _Time = require("../../../Time");
var _chartUtils = require("../utils/chartUtils");
var _styles = require("../styles");
var _StackedBarChart = require("../../../Recharts/Charts/StackedBarChart");
var _core = require("@blueprintjs/core");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var COLORS = ["#00A796", "#F6928F", "#6FC376", "#FBBC6D", "#B1DAAE", "#CDA5CD", "#5DA5DA", "#C1C1C1"];
var AlertsPerDeviceChart = exports.AlertsPerDeviceChart = function AlertsPerDeviceChart(_ref) {
  var data = _ref.data,
    period = _ref.period,
    title = _ref.title,
    devices = _ref.devices,
    width = _ref.width;
  var time = _react["default"].useContext(_Time.TimeContext);
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var ref = _react["default"].useRef(null);
  var _React$useState = _react["default"].useState("day"),
    groupBy = _React$useState[0],
    setGroupBy = _React$useState[1];
  var _React$useState2 = _react["default"].useState(false),
    isLoaded = _React$useState2[0],
    setIsLoaded = _React$useState2[1];
  var _React$useState3 = _react["default"].useState([]),
    formattedData = _React$useState3[0],
    setFormattedData = _React$useState3[1];
  (0, _react.useEffect)(function () {
    setFormattedData(groupData(data || [], time, devices, groupBy));
    setIsLoaded(true);
  }, []);
  (0, _react.useEffect)(function () {
    setIsLoaded(false);
    setFormattedData(groupData(data || [], time, devices, groupBy));
    setIsLoaded(true);
  }, [groupBy]);
  var _period$split = period.split("/"),
    start = _period$split[0],
    end = _period$split[1];
  var deviceColors = data.map(function (item) {
    return item.device;
  }).filter(function (item, index, array) {
    return array.indexOf(item) === index;
  }).map(function (item, index) {
    return {
      key: getDeviceName(devices, item),
      color: COLORS[index % COLORS.length]
    };
  });
  var selectedInterval = (0, _chartUtils.getSelectedInterval)({
    start: start,
    end: end
  });
  var chartProps = (0, _chartUtils.getChartProps)({
    start: start,
    end: end
  }, {
    selectedInterval: selectedInterval,
    timezone: time.timezone,
    hideAxis: false
  }, {
    enableYDomain: true,
    minYValue: 0,
    maxYValue: Math.max.apply(Math, formattedData.map(function (item) {
      return item.sum;
    })),
    hideAxis: false
  }, {
    yValueName: "",
    xValueFormat: getXValueFormat(groupBy)
  });
  chartProps.tooltipProps.yValueFormatter = function (data) {
    return data.reduce(function (yValues, _ref2, index) {
      var payload = _ref2.payload;
      return [].concat(yValues, [{
        name: payload == null ? void 0 : payload.keys[index].key,
        color: payload == null ? void 0 : payload.keys[index].color,
        value: payload[payload == null ? void 0 : payload.keys[index].key]
      }]);
    }, []);
  };
  return /*#__PURE__*/_react["default"].createElement(_styles.ChartWrapper, {
    ref: ref,
    "data-testid": "AlertsAnalysis.AlertsPerDeviceChart.container"
  }, isLoaded ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.ChartTitle, null, title), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginLeft: "50px",
      width: "100%",
      textAlign: "center"
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.RadioGroup, {
    "data-testid": "AlertsAnalysis.AlertsPerDeviceChart.GroupByTime.group",
    inline: true,
    onChange: function onChange(e) {
      return setGroupBy(e.currentTarget.value);
    },
    selectedValue: groupBy
  }, /*#__PURE__*/_react["default"].createElement(_core.Radio, {
    "data-testid": "AlertsAnalysis.AlertsPerDeviceChart.radio.day",
    value: "day",
    label: translate("AlertsAnalysis.AlertsPerDeviceChart.groupByDay", "Group By Day")
  }), /*#__PURE__*/_react["default"].createElement(_core.Radio, {
    "data-testid": "AlertsAnalysis.AlertsPerDeviceChart.radio.week",
    value: "week",
    label: translate("AlertsAnalysis.AlertsPerDeviceChart.groupByweek", "Group By Week")
  }), /*#__PURE__*/_react["default"].createElement(_core.Radio, {
    "data-testid": "AlertsAnalysis.AlertsPerDeviceChart.radio.month",
    value: "month",
    label: translate("AlertsAnalysis.AlertsPerDeviceChart.groupBymonth", "Group By Month")
  }), /*#__PURE__*/_react["default"].createElement(_core.Radio, {
    "data-testid": "AlertsAnalysis.AlertsPerDeviceChart.radio.year",
    value: "year",
    label: translate("AlertsAnalysis.AlertsPerDeviceChart.groupByyear", "Group By Year")
  }))), /*#__PURE__*/_react["default"].createElement(_StackedBarChart.StackedBarChart, {
    colors: deviceColors,
    width: width,
    height: 400,
    series: formattedData,
    data: formattedData.map(function (item) {
      return {
        key: item.key
      };
    }),
    xAxisProps: chartProps.xAxisProps,
    yAxisProps: chartProps.yAxisProps,
    tooltipProps: chartProps.tooltipProps
  })) : /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null));
};
var groupData = function groupData(data, time, devices, groupBy) {
  return (0, _chartUtils.sumAlertCounts)(data, function (item) {
    return (0, _chartUtils.rollupCountDay)(item.day, groupBy, time.timezone.name);
  }).map(function (item) {
    return {
      key: item.key,
      sum: item.count,
      values: item.rows.reduce(function (acc, alert) {
        var existingValue = acc.find(function (element) {
          return element.key === alert.device;
        });
        if (existingValue) existingValue.value += alert.count;else acc.push({
          key: alert.device,
          value: alert.count
        });
        return acc;
      }, [])
    };
  }).map(function (item) {
    var devicesData = item.values.reduce(function (acc, value, index) {
      acc[getDeviceName(devices, value.key)] = value.value;
      if (!acc.keys) {
        acc.keys = [];
      }
      acc.keys.push({
        key: getDeviceName(devices, value.key),
        color: COLORS[index % COLORS.length]
      });
      return acc;
    }, {});
    return Object.assign({}, devicesData, {
      key: item.key,
      sum: item.sum
    });
  });
};
var getDeviceName = function getDeviceName(devices, uuid) {
  var device = devices.find(function (device) {
    return device.uuid === uuid;
  });
  return device ? device.name : uuid;
};
var getXValueFormat = function getXValueFormat(groupBy) {
  switch (groupBy) {
    case "day":
    case "week":
      return "YYYY-MM-DD";
    case "month":
      return "YYYY-MM";
    case "year":
      return "YYYY";
    default:
      return "YYYY-MM-DD";
  }
};